'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuizFreeAnswer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(QuizFreeAnswer, _Component);

  function QuizFreeAnswer(props) {
    (0, _classCallCheck3.default)(this, QuizFreeAnswer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (QuizFreeAnswer.__proto__ || (0, _getPrototypeOf2.default)(QuizFreeAnswer)).call(this, props));

    _this.handleOnAnswerChange = function (index, value) {
      var _this$props = _this.props,
          answer = _this$props.answer,
          onChange = _this$props.onChange;

      answer.rows[index].answer = value;
      onChange(answer);
    };

    _this.handleOnPrefixChange = function (index, value) {
      var _this$props2 = _this.props,
          answer = _this$props2.answer,
          onChange = _this$props2.onChange;

      answer.rows[index].prefix = value;
      onChange(answer);
    };

    _this.handleOnHelpMessageChange = function (event) {
      var _this$props3 = _this.props,
          answer = _this$props3.answer,
          onChange = _this$props3.onChange;

      answer.helpMessage = event.target.value;
      onChange(answer);
    };

    _this.handleAddAnswerRow = function () {
      var _this$props4 = _this.props,
          answer = _this$props4.answer,
          onChange = _this$props4.onChange;

      answer.rows.push({
        prefix: '',
        answer: ''
      });
      onChange(answer);
    };

    _this.handleDeleteAnswerRow = function (index) {
      var _this$props5 = _this.props,
          answer = _this$props5.answer,
          onChange = _this$props5.onChange;

      answer.rows.splice(index, 1);
      onChange(answer);
    };

    return _this;
  }

  (0, _createClass3.default)(QuizFreeAnswer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          answer = _props.answer,
          innerHTML = _props.innerHTML;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'label',
            null,
            'Texte d\'aide (facultatif)'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('textarea', {
            style: { width: '350px' },
            onChange: this.handleOnHelpMessageChange,
            value: answer.helpMessage
          })
        ),
        answer.rows.map(function (row, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { marginTop: '12px' } },
            answer.rows.length > 1 && _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'span',
                null,
                'Ligne ',
                index + 1
              ),
              _react2.default.createElement(
                'div',
                { onClick: function onClick() {
                    return _this2.handleDeleteAnswerRow(index);
                  }, style: { cursor: 'pointer' } },
                '\u274C'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex' } },
              _react2.default.createElement(
                'div',
                { style: { marginRight: '12px' } },
                _react2.default.createElement(
                  'label',
                  null,
                  'Pr\xE9fixe (facultatif)'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement('input', {
                  type: 'text',
                  style: {
                    width: '80px',
                    padding: '4px 8px',
                    fontSize: '14px'
                  },
                  value: row.prefix,
                  onChange: function onChange(event) {
                    return _this2.handleOnPrefixChange(index, event.target.value);
                  }
                })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'label',
                  null,
                  'R\xE9ponse attendue'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement('input', {
                  type: 'text',
                  style: {
                    width: '300px',
                    padding: '4px 8px',
                    fontSize: '14px'
                  },
                  value: row.answer,
                  onChange: function onChange(event) {
                    return _this2.handleOnAnswerChange(index, event.target.value);
                  }
                })
              )
            )
          );
        }),
        _react2.default.createElement(
          'button',
          { style: { marginTop: '12px' }, onClick: this.handleAddAnswerRow },
          'Ajouter une ligne de r\xE9ponse'
        ),
        _react2.default.createElement('hr', null),
        answer.helpMessage && _react2.default.createElement(
          'div',
          { style: { fontStyle: 'italic' } },
          innerHTML(answer.helpMessage)
        ),
        answer.rows.map(function (row, index) {
          return _react2.default.createElement(
            'div',
            { key: index, style: { marginTop: '12px' } },
            answer.rows.length > 1 && _react2.default.createElement(
              'span',
              null,
              'Ligne ',
              index + 1
            ),
            _react2.default.createElement(
              'div',
              { key: index, style: { display: 'flex', alignItems: 'center' } },
              row.prefix && _react2.default.createElement(
                'span',
                { style: { padding: '6px 10px', background: '#F3F3F3', borderRadius: '4px', marginRight: '4px' } },
                innerHTML('$' + row.prefix + '$')
              ),
              _react2.default.createElement(
                'span',
                { style: { padding: '6px 10px', border: '1px solid #F3F3F3', borderRadius: '4px' } },
                innerHTML('$' + row.answer + '$')
              )
            )
          );
        })
      );
    }
  }]);
  return QuizFreeAnswer;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  answer: _react.PropTypes.object.isRequired,
  innerHTML: _react.PropTypes.func.isRequired
}, _temp);
exports.default = QuizFreeAnswer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/QuizFreeAnswer.js
// module id = 1195
// module chunks = 0